export const dva = {
  config: {
    onError(err) {
      err.preventDefault()
      console.error(err.message)
    },
  },
}

/* eslint-disable */
console.log('当前版本:', VERSION)
